import React from 'react';
import PropTypes from 'prop-types';

import Count from '../../components/Count';
import ShowMore from '../../components/ShowMore';
import { getSeasonsInfo, getRunStatus } from '../../utils/show';
import { addBulletIfSet } from '../../utils/shared';

import './styles/ShowInfo.css';

const ShowInfo = props => {
  const { show, count } = props;

  const genre = show.genre
    ? show.genre
        .split('|')
        .filter(g => g && g.length > 0)
        .map(g => g.trim())
        .join(', ')
    : null;

  return (
    <div className="show-info-root">
      <img
        className="show-thumbnail"
        alt={`${show.name} thumbnail`}
        src={show.poster}
      />
      <div className="show-info__wrapper">
        <h1 className="show-title">{show.name}</h1>
        <p className="show-info">
          {getRunStatus(show)}
          {addBulletIfSet(genre)}
          {genre || ''}
          {addBulletIfSet(1)}
          {show.network ? show.network : 'Network TBD'}
          {addBulletIfSet(1)}
          {show.number_of_seasons !== null && show.number_of_seasons > 0
            ? getSeasonsInfo(show)
            : ''}
        </p>
        <ShowMore text={show.overview} maxLength={190} />
        {count ? (
          <Count count={count} unitSingular="Follower" unitPlural="Followers" />
        ) : null}
      </div>
    </div>
  );
};

ShowInfo.propTypes = {
  show: PropTypes.shape({
    name: PropTypes.string,
    poster: PropTypes.string,
    network: PropTypes.string,
    overview: PropTypes.string,
    genre: PropTypes.string,
    number_of_seasons: PropTypes.number
  }).isRequired,
  count: PropTypes.number
};

ShowInfo.defaultProps = {
  count: 0
};

export default ShowInfo;
